module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/7-955bcfe37e84cde502da6f03140d7a4e.png";